"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = exports.StoryStatus = exports.StayStatus = exports.OriginDirectionType = exports.MenuSlideAnchorDirectionType = exports.FormProvider = exports.DropdownButtonColors = exports.DatePickerType = exports.DateDisplayFormat = exports.CalendarDayStatus = exports.AnchorDirectionType = exports.ActionTooltipType = void 0;

/*eslint-disable */
function Enum(a) {
  var i = Object.keys(a).reduce(function (o, k) {
    return o[a[k]] = k, o;
  }, {});
  return Object.freeze(Object.keys(a).reduce(function (o, k) {
    return o[k] = a[k], o;
  }, function (v) {
    return i[v];
  }));
}

var StoryStatus = Enum({
  Verified: "\u2713",
  Deprecated: "\u26A0",
  Failed: "\xD7"
});
exports.StoryStatus = StoryStatus;
var Theme = Enum({
  Light: 'light',
  Dark: 'dark',
  Error: 'error',
  Yellow: 'yellow'
});
exports.Theme = Theme;
var StayStatus = Enum({
  Planned: 'pre',
  Staying: 'curr',
  Complete: 'post',
  Reserved: 'reserved'
});
exports.StayStatus = StayStatus;
var CalendarDayStatus = Enum({
  Booked: 'booked',
  Reserved: 'reserved',
  Available: 'available',
  Unavailable: 'unavailable',
  Confirmed: 'confirmed'
});
exports.CalendarDayStatus = CalendarDayStatus;
var DropdownButtonColors = Enum({
  primary: 'blue',
  success: 'green',
  warning: 'yellow',
  danger: 'red',
  secondary: 'gray-dark'
});
exports.DropdownButtonColors = DropdownButtonColors;
var DatePickerType = Enum({
  Single: 'single',
  Range: 'range'
});
exports.DatePickerType = DatePickerType;
var DateDisplayFormat = 'MMM D, YYYY';
exports.DateDisplayFormat = DateDisplayFormat;
var ActionTooltipType = Enum({
  Button: 'button',
  Link: 'link'
});
exports.ActionTooltipType = ActionTooltipType;
var AnchorDirectionType = Enum({
  Left: 'left',
  Center: 'center',
  Right: 'right',
  EndCenter: 'end center',
  StartCenter: 'start center',
  Start: 'start',
  End: 'end'
});
exports.AnchorDirectionType = AnchorDirectionType;
var OriginDirectionType = Enum({
  Top: 'top',
  Bottom: 'bottom',
  Left: 'left',
  Right: 'right'
});
exports.OriginDirectionType = OriginDirectionType;
var MenuSlideAnchorDirectionType = Enum({
  Top: 'top',
  Bottom: 'bottom',
  Center: 'center',
  Left: 'left',
  Right: 'right'
});
exports.MenuSlideAnchorDirectionType = MenuSlideAnchorDirectionType;
var FormProvider = Enum({
  Redux: 'redux',
  Final: 'final'
});
exports.FormProvider = FormProvider;